export default __webpack_public_path__ + "static/media/polk_welcome_banner.dbd6d94d.jpg";